module.exports = __webpack_public_path__ + "img/art5-img4.02248ad1.jpeg";